<div id="page--home">

    <div class="content__holder">
      <h2 class="heading">Home Fire Safety Visit (HFSV) Admin</h2>

      <div class="panel">
        <H4>Welcome</H4>
      </div>
    </div>

</div>
